export enum TelematicsSort {
  ORDER_DELAY_DESC = 'orderDelayDesc',
  ORDER_DELAY_ASC = 'orderDelayAsc',
  REMAINING_DAILY_DRIVING_TIME_DESC = 'remainingDailyDrivingTimeDesc',
  REMAINING_DAILY_DRIVING_TIME_ASC = 'remainingDailyDrivingTimeAsc',
  FREE_SINCE_ASC = 'freeTimeAsc',
  FREE_SINCE_DESC = 'freeTimeDesc',
  DELEGATION_END_TIME_ASC = 'delegationEndTimeAsc',
  DELEGATION_END_TIME_DESC = 'delegationEndTimeDesc',
  REGISTRATION_NUMBER_ASC = 'registrationNumberAsc',
  REGISTRATION_NUMBER_DESC = 'registrationNumberDesc',
}
